import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { StoreState } from 'store/ducks';
import { openLoader } from 'utils/localDispatcher';
import { BizProfileParamConverter, getBizChatUrl, getUrlParams, ProfileParamConverter } from 'utils/snippet';

const ChannelListSidebar = () => {
  const bizAccount = useSelector((state: StoreState) => state.authStore.bizAccount);
  const userAccount = useSelector((state: StoreState) => state.authStore.user);
  const userProfile = useSelector((state: StoreState) => state.authStore.profileImage);
  const selectUser = useSelector((state: StoreState) => state.authStore.selectUser);
  const unreadObj = useSelector((state: StoreState) => state.chatStore.unreadObj);
  const selectChannelobj = useSelector((state: StoreState) => state.chatStore.selectChannelobj);

  const dispatch = useDispatch();
  const sortedBizAccount = useMemo(() => {
    return [...bizAccount].sort((a, b) => (unreadObj[b.id] || 0) - (unreadObj[a.id] || 0));
  }, [bizAccount, unreadObj]);
  useEffect(() => {
    if (userAccount.id && selectUser !== userAccount.id) {
      dispatch({
        type: 'user/setSelectUser',
        payload: {
          id: userAccount.id,
          type: 'normal',
          nickname: userAccount.nick,
        },
      });
    }
  }, [dispatch, userAccount, selectUser]);

  const handleClick = (userId: number) => {
    if (selectUser !== userId) {
      openLoader();
    }
  };

  useEffect(() => {
    const totalUnread = Object.values(unreadObj).reduce((acc, cur) => acc + cur, 0);
    const { accountType } = getUrlParams();
    const totalNotation = totalUnread > 0 ? `(${totalUnread})` : '';
    if (Object.keys(unreadObj).length < 1) return;
    if (accountType === '') {
      document.title = `${totalNotation}${userAccount.nick} | 당근채팅`;
    } else if (accountType === 'room') {
      if (
        selectChannelobj?.resourceType === 'STOR' ||
        selectChannelobj?.resourceType === 'MEET' ||
        selectChannelobj?.resourceType === 'CBUY'
      ) {
        document.title = `${totalNotation}${selectChannelobj?.title} - ${userAccount.nick} | 당근채팅`;
      } else {
        if (selectChannelobj) {
          if(selectChannelobj.type === 2){
            document.title = `${totalNotation}${selectChannelobj.title} - ${userAccount.nick} | 당근채팅`;
          } else {
            document.title = `${totalNotation}${selectChannelobj?.receiver?.nickname} - ${userAccount.nick} | 당근채팅`;
          }
        }
      }
    }
  }, [unreadObj, selectChannelobj, userAccount]);
  return (
    <nav className="sidebar">
      {userAccount.id ? (
        <Link className="anchor" to={'/'}>
          <img
            className={`${selectUser === userAccount.id ? 'selected' : ''} profile-image`}
            src={ProfileParamConverter(userProfile)}
            alt={userAccount.nick}
            onClick={() => handleClick(userAccount.id)}
          />
          {selectUser === userAccount.id ? null : <div className="tooltip">{userAccount.nick}</div>}
          {unreadObj[-1] > 0 ? <div className="unread-count" /> : null}
        </Link>
      ) : null}
      {sortedBizAccount.map((bizItem) => (
        // 비즈프로필은 신규 비즈채팅 웹으로 이동한다. 표시(이미지·툴팁·안읽음 점)는 개인 프로필과 동일하게 유지한다.
        <a className="anchor" href={getBizChatUrl(bizItem.id)} key={bizItem.id}>
          <img className="profile-image" src={BizProfileParamConverter(bizItem.imageUrl)} alt={bizItem.name} />
          <div className="tooltip">{bizItem.name}</div>
          {unreadObj[bizItem.id] > 0 ? <div className="unread-count" /> : null}
        </a>
      ))}
    </nav>
  );
};

export default ChannelListSidebar;
